import React, { useState } from "react";
import * as API from "../../utils/api.service";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import {
  convertToBase64,
  TOAST_ERROR,
  SWIT_SUCCESS,
} from "../../utils/common.service";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function AddBadge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [badgeImageState, setBadgeImage] = useState(null);

  const handleImageChange = async (image, setImageState, fieldName) => {
    const imageSize = image.size / 1024; // Convert size to KB
    if (imageSize > 3072) {
      TOAST_ERROR("Please select an image smaller than 3MB");
      return;
    }

    try {
      setValue(fieldName, image);
      const bufferImage = await convertToBase64(image);
      setImageState(bufferImage);
      clearErrors(fieldName);
    } catch (error) {
      TOAST_ERROR("An error occurred while processing the image");
    }
  };

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));

      let { image, name,arebic_name,points } = submitData;

      // Initialize variables to hold URLs of uploaded images
      let uploadedBadgeImage = image;

      // Upload the badge image to AWS if it's a Blob
      if (image instanceof Blob) {
        try {
          uploadedBadgeImage = await uploadImageOnAWS(image, "badge");
        } catch (error) {
          TOAST_ERROR("Error uploading Badge image");
        }
      }

      // Construct the request body
      const requestBody = {
        image: uploadedBadgeImage,
        name,
        arebic_name,
        points,
      };

      // Make the API call
      const { code, message } = await API.insertBadgeApi(requestBody);

      if (code === "1") {
        SWIT_SUCCESS(message);
        navigate(`/manage_badge`);
        reset();
      }

      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title="Add Badge" header="Badge" subHeader="Add Badge" />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <IoMdArrowRoundBack fontSize={"20px"}/>
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row mb-3 d-flex justify-content-center">
                  {/* Badge Image */}
                  <Controller
                    name="image"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Please choose a badge image" }}
                    render={({ field }) => (
                      <div className="col-md-4 text-center">
                        {badgeImageState && (
                          <img
                            src={badgeImageState}
                            alt="Badge image"
                            className="img-fluid img-thumbnail"
                            style={{ width: "120px", borderRadius: "10%" }}
                          />
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="badge_image"
                          accept=".jpg, .jpeg, .png"
                          onChange={(e) =>
                            handleImageChange(
                              e.target.files[0],
                              setBadgeImage,
                              "image"
                            )
                          }
                        />
                        <label
                          htmlFor="badge_image"
                          className="btn btn-outline-info m-1"
                        >
                          Choose Badge Image
                        </label>
                        <div className="errorc">{errors.image?.message}</div>
                      </div>
                    )}
                  />
                </div>

                {/* Badge Name and Points Input */}

                <div className="row mb-3">
                  <div className="col-md-4">
                    <label htmlFor="name" className="form-label">
                      Badge Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter Badge Name"
                      {...register("name", {
                        required: "Badge Name is required",
                      })}
                    />
                    <div className="errorc">{errors.name?.message}</div>
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="name" className="form-label">
                      Badge Arebic Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter Badge Arebic Name"
                      {...register("arebic_name", {
                        required: "Arebic Badge Name is required",
                      })}
                    />
                    <div className="errorc">{errors.arebic_name?.message}</div>
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="points" className="form-label">
                      Badge Points
                    </label>
                    <input
                      type="number"
                      id="points"
                      className="form-control"
                      placeholder="Enter Points"
                      {...register("points", {
                        required: "Points is required",
                      })}
                    />
                    <div className="errorc">{errors.points?.message}</div>
                  </div>
                </div>

                <div className="mb-0 text-center">
                  <button
                    className="btn btn-soft-primary w-25 buttonColor"
                    type="submit"
                  >
                    <i className="ri-save-fill"></i>{" "}
                    <span className="fw-bold">Add</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
